import React from 'react';
import { TextField } from '@mui/material';
import type { TextFieldProps } from '@mui/material';
import { validateUpc } from '../../utils/inputValidators';

type BarcodeTextFieldProps = Omit<TextFieldProps, 'variant'> & {
  value: string;
  /** Set false to render a plain field (e.g. one loop over SKU, MPN and barcode fields). Default true. */
  validate?: boolean;
};

/**
 * TextField for a UPC / EAN / GTIN / JAN. Typing is never blocked; once the box
 * loses focus a malformed or mistyped barcode shows the validator message as
 * helper text (taking the place of the field's own helper until fixed).
 */
export const BarcodeTextField: React.FC<BarcodeTextFieldProps> = ({
  value,
  validate = true,
  helperText,
  error,
  onBlur,
  ...rest
}) => {
  const [touched, setTouched] = React.useState(false);
  const problem = validate && touched ? validateUpc(value) : null;
  return (
    <TextField
      {...rest}
      value={value}
      onBlur={(e) => {
        setTouched(true);
        onBlur?.(e);
      }}
      error={Boolean(error) || Boolean(problem)}
      helperText={problem ?? helperText}
    />
  );
};
